document.addEventListener("turbolinks:before-cache", function() {
  const flash_message_element = document.querySelector(".flash")
  if (flash_message_element) {
    flash_message_element.remove()
  }
})
